import React from 'react';
import { Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Guardian } from '@xaamin/guardian';
import NavLink from '../components/NavLink';

const AdminSidebar = ({ onMenuItemClick }) => {
  return (
    <div className="sidebar-container-alt">
      <div className="scrollbar">
        <Nav className="flex-column">
          <Nav.Link
            as={NavLink}
            eventKey="go-dashboard"
            to="/app/dashboard"
            className="go-to-dashboard"
            onClick={onMenuItemClick}
          >
            <FontAwesomeIcon
              icon={['fas', 'arrow-left']}
              className="mr-2"
            />
            <span className="nav-link-text">DASHBOARD</span>
          </Nav.Link>

          <Nav.Link
            eventKey="disabled"
            disabled
            className="divider-simple"
          ></Nav.Link>
          {Guardian.allows('root.access') && (
            <>
              {/* <Nav.Link as={ NavLink } eventKey="dashboard" to="/admin/dashboard" onClick={ onMenuItemClick }>
                <FontAwesomeIcon icon={ ['fas', 'tachometer-alt'] } />
                <span className="nav-link-text">Dashboard</span>
              </Nav.Link> */}
              <Nav.Link
                as={NavLink}
                eventKey="clientes"
                to="/admin/clientes"
                onClick={onMenuItemClick}
              >
                <FontAwesomeIcon icon={['fas', 'users']} />
                <span className="nav-link-text">Clientes</span>
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                eventKey="pacs"
                to="/admin/pacs"
                onClick={onMenuItemClick}
              >
                <FontAwesomeIcon icon={['fas', 'rocket']} />
                <span className="nav-link-text">Pacs</span>
              </Nav.Link>
            </>
          )}

          <Nav.Link
            eventKey="disabled"
            disabled
          >
            Reportes
          </Nav.Link>

          <Nav.Link
            as={NavLink}
            eventKey="hits"
            to="/admin/reportes/pac-balance"
            onClick={onMenuItemClick}
          >
            <FontAwesomeIcon icon={['fas', 'chart-line']} />
            <span className="nav-link-text">Balance pacs</span>
          </Nav.Link>

          <Nav.Link
            as={NavLink}
            eventKey="hits"
            to="/admin/reportes/facturacion"
            onClick={onMenuItemClick}
          >
            <FontAwesomeIcon icon={['fas', 'chart-line']} />
            <span className="nav-link-text">Facturación</span>
          </Nav.Link>

          <Nav.Link
            as={NavLink}
            eventKey="hits"
            to="/admin/reportes/hits-por-pac"
            onClick={onMenuItemClick}
          >
            <FontAwesomeIcon icon={['fas', 'chart-line']} />
            <span className="nav-link-text">Hits por pac</span>
          </Nav.Link>

          <Nav.Link
            as={NavLink}
            eventKey="hits"
            to="/admin/reportes/storage"
            onClick={onMenuItemClick}
          >
            <FontAwesomeIcon icon={['fas', 'chart-line']} />
            <span className="nav-link-text">Storage</span>
          </Nav.Link>

          <Nav.Link
            as={NavLink}
            eventKey="hits"
            to="/admin/reportes/clientes"
            onClick={onMenuItemClick}
          >
            <FontAwesomeIcon icon={['fas', 'chart-line']} />
            <span className="nav-link-text">Nuevos clientes</span>
          </Nav.Link>
        </Nav>
      </div>
    </div>
  );
};

export default AdminSidebar;
